import { Unit } from "@shared/api/types"
import i18next from "i18next"

export const mapUnitToLocalizedUnit = (unit: Unit): string =>
	(
		({
			[Unit.Kg]: i18next.t("shared:units.kg"),
			[Unit.KgCo2]: i18next.t("shared:units.kgCO2"),
			[Unit.Tons]: i18next.t("shared:units.ton"),
			[Unit.M3]: i18next.t("shared:units.m3"),
			[Unit.KgPerTons]: i18next.t("shared:units.kg"),
		}) satisfies Record<Unit, string>
	)[unit]
